import React from "react";
import { HeartPulse } from "lucide-react";
import VerticalPage from "@/pages/VerticalPage";

const TYPE_OPTIONS = [
  { value: "prescription", label: "Prescription" },
  { value: "report",       label: "Lab report" },
  { value: "scan",         label: "Scan / X-ray" },
  { value: "vaccination",  label: "Vaccination" },
  { value: "consultation", label: "Consultation" },
  { value: "other",        label: "Other" },
];

export default function Medical() {
  return (
    <VerticalPage
      title="Medical"
      subtitle="Reports, prescriptions, history"
      endpoint="/medical"
      singularType="medical"
      icon={HeartPulse}
      colorClass="text-rose-500 bg-rose-500/12"
      emptySubtitle="Keep every prescription, report and vaccination together for quick access."
      typeField={{ name: "med_type", label: "Record type", options: TYPE_OPTIONS }}
      sections={[
        {
          title: "Record",
          fields: [
            { name: "title",       label: "Title",       type: "text", placeholder: "e.g. Chest X-Ray", required: true, colSpan: 2 },
            { name: "for_person",  label: "For",         type: "text", placeholder: "Self / family member" },
            { name: "record_date", label: "Record date", type: "date" },
            { name: "doctor",      label: "Doctor",      type: "text", placeholder: "e.g. Dr. Sharma" },
            { name: "hospital",    label: "Hospital / Lab", type: "text", placeholder: "e.g. Apollo" },
          ],
        },
        {
          title: "Notes",
          fields: [
            { name: "notes", label: "Notes", type: "textarea", placeholder: "Diagnosis / instructions", colSpan: 2 },
          ],
        },
      ]}
      formatMeta={(it) => {
        const typeLbl = TYPE_OPTIONS.find((o) => o.value === it.med_type)?.label;
        const line1 = [typeLbl, it.record_date].filter(Boolean).join(" · ");
        const line2 = [it.doctor, it.hospital].filter(Boolean).join(" · ");
        return { line1, line2 };
      }}
    />
  );
}
